/**
 * @file   src\components\Tutorial\MatchTutorialModal.js
 * @brief  This file is responsible for match section tutorial
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import InvTutsImg from "../../images/inventory-tuts-image.png";

const MatchTutoral = (props) => {

  return (
    <Modal
      show
      centered
      backdropClassName="white-backdrop"
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-left-aligned modal-match-tutorial left"
    >
      <Modal.Body className="pt-24 pb-24 pl-24 pr-24">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            props.onHide();
          }}
        ></button>

        <h6>You've got a new match ⚡️</h6>
        <p className="mb-2">
          It looks like people are looking for properties that are similar to
          yours. See which want listings you're matching to.
        </p>

        <img src={InvTutsImg} />
      </Modal.Body>
    </Modal>
  );
};
export default MatchTutoral;
